<template>
    <div class="profile-section">
        <div class="to-entities">
            <router-link :to="{ name: 'dashboard' }">
                <el-button class="redirect-button" type="text" icon="el-icon-arrow-left">ENTITIES</el-button>
            </router-link>
        </div>
        <div class="header">
            <h2 class="header-title">Profile</h2>
        </div>
        <div class="profile-settings-container">
            <el-form
                :model="form"
                ref="profile-form"
                :rules="rules"
                label-position="top"
                size="small"
                label-width="100px"
                hide-required-asterisk
            >
                <div class="identity">
                    <h3 class="sub-title">IDENTITY</h3>
                    <el-form-item prop="email" label="Email">
                        <el-input v-model="$store.getters.currentUser.email" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="password">
                    <h3 class="sub-title">PASSWORD</h3>
                    <el-alert
                        ref="passwordRuleError"
                        :closable="false"
                        class="rule-alert"
                        type="info"
                        dark
                    >
                        <p>Rules</p>
                        <div
                            v-if="securityRules === null"
                            v-loading="true"
                            element-loading-text="Searching for rules"
                            element-loading-background="rgb(244,244,245)"
                            class="loading-rules"
                        ></div>
                        <p v-else-if="securityRules === 'error'" class="rule-error text-center">
                            Server error, rules can't be fetched
                        </p>
                        <template v-else>
                            <ul v-if="securityRules.length">
                                <template v-for="(rule, index) in securityRules" >
                                    <li :key="index" :class="rule.code === serverError ? 'rule-error rule-message' : ''">
                                        {{ rule['message_en'] }}
                                    </li>
                                </template>
                            </ul>
                            <p v-else class="text-center rule-message">No rules available.</p>
                        </template>
                    </el-alert>
                    <el-form-item prop="newPassword" label="New password">
                        <el-input type="password" show-password v-model="form.newPassword"></el-input>
                    </el-form-item>
                    <el-form-item prop="newPasswordConfirm" label="Confirm new password">
                        <el-input type="password" show-password v-model="form.newPasswordConfirm"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <el-button class="save-button" type="text" @click="saveProfile">Edit</el-button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import HttpErrorManager from 'fundation-app-vuejs/src/components/partials/http-error-manager.js';
export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            form: {
                newPassword: '',
                newPasswordConfirm: '',
            },
            securityRules: [],
            httpErrorManager: null,
            serverError: '',
            rules: {
                newPassword: [{
                    required: true,
                    message: 'New password is required',
                    trigger: 'blur',
                }],
                newPasswordConfirm: [{
                    required: true,
                    message: 'New password confirmation is required',
                    trigger: 'blur',
                }],
            }
        };
    },

    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        rulesCodes (){
            return this.securityRules.map(rule => rule.code);
        },
    },

    mounted (){
        this.$store.dispatch('listSecurityRyles').then((rules) => {
            this.$set(this, 'securityRules', rules || []);
        }).catch(() => {
            this.securityRules = 'error';
        });
        this.httpErrorManager = new HttpErrorManager('en');

    },

    methods: {
        saveProfile() {
            this.$refs['profile-form'].validate((valid) => {
                if (valid) {
                    this.$store.dispatch('changeUserPassword', {
                        email: this.form.email,
                        password1: this.form.newPassword,
                        password2: this.form.newPasswordConfirm
                    }).then(() => {
                        this.$message({
                            message: 'Successfully changed your password',
                            type: 'success'
                        });
                    }).catch((error) => {
                        this.serverError = this.httpErrorManager.getFirstCode(
                            error.response.data._errors);
                        if(this.rulesCodes.includes(this.serverError)){
                            this.$refs.passwordRuleError.$el.animate(
                                [
                                    { transform: 'translateX(0px)'},
                                    { transform: 'translateX(-10px)'},
                                    { transform: 'translateX(10px)'},
                                ],
                                {
                                    iterations: 2,
                                    duration: 150,
                                }
                            );
                        }
                        this.$message({
                            message: error.response.data.message,
                            type: 'error'
                        });
                    });
                } else {
                    return false;
                }
            });
        }
    },
};
</script>

<style lang="scss">

.profile-section {
        width: 100%;
        max-width: 680px;
        position: relative;
        z-index: 2;
    .to-entities {
        .redirect-button {
            font-size: 9px;
            color: #BBBBBB;
        }
    }
    .header {
        .header-title {
            font-size: 30px;
            line-height: 1.1;
        }
        margin-bottom: 20px;
    }
    .profile-settings-container {
        padding: 35px 40px;
        background: linear-gradient(180deg, #222222 0%, #111111 61.77%);
        border-radius: 5px;
        .password {
            margin-top: 45px;

            .el-form-item {
                margin-bottom: 20px;
            }
            .el-input__icon {
                color: #222222 !important;
            }
        }
        .sub-title {
            margin: 0;
            font-weight: 900;
            font-size: 18px;
            color: #BBBBBB;
            margin-bottom: 25px;
        }
        .el-form-item__label {
            height: 12px;
            line-height: 12px;
            font-weight: 300;
            font-size: 12px;
            color: #BBBBBB;
            margin-bottom: 7px;
        }
        .el-input {
            width: 350px;
            input {
                border: none;
                border-radius: 4px;
                height: 30px;
                color: #BBBBBB;
                background: #444444;
                &::placeholder {
                    color: #222222;
                    opacity: 1; /* Firefox */
                }
                &::disabled {
                    color: #222222;
                }
            }
        }
        .save-button {
            margin-left: 300px;
            width: 50px;
            height: 30px;
            background: #BBBBBB;
            border-radius: 2px;
            padding: 0;
            color: #444444;
            font-size: 12px;
            &:hover {
                background: #00A3FF;
                color: #FFFFFF;
            }
        }
    }

    .rule-alert{
        background-color: #222;
        margin-bottom: 20px;
        .el-alert__content{
            width: 100%;
        }

        .rule-error{
            color: #F56C6C;
        }
        .rule-message{
            font-weight: bold;
        }
    }
    .loading-rules{
        width: 100%;
        height: 120px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Profile/profile-section.vue